export const messages = {
  en: {
    integralRule: {
      page: {
        title: 'Integral Rules',
        subtitle: 'Manage integral calculation rules, quota configuration and fee settings'
      },
      addTitle: 'Add Integral Rule',
      editTitle: 'Edit Integral Rule',
      deleteTitle: 'Delete Integral Rule',
      deleteConfirm: 'Are you sure to delete this integral rule?',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 64 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkRequired: 'Remark is required',
      remarkMaxLength: 'Remark cannot exceed 512 characters',
      ruleIdRequired: 'Rule ID is required',
      selectRule: 'Please select a rule first',
      
      // Config related
      addConfigTitle: 'Add Integral Config',
      configId: 'Config ID',
      configName: 'Config Name',
      configPlaceholder: 'Please select config',
      configRequired: 'Config is required',
      deleteConfigConfirm: 'Are you sure to delete this config?',
      computingFormula: 'Computing Formula',
      squarePrice: 'Square Price',
      additionalAmount: 'Additional Amount',
      scale: 'Scale',
      
      // Fee related
      addFeeTitle: 'Add Payment Time',
      editFeeTitle: 'Edit Payment Time',
      feeId: 'Fee ID',
      payTimeRange: 'Payment Time Range',
      payStartTime: 'Start Time',
      payStartTimePlaceholder: 'Select start time',
      payStartTimeRequired: 'Start time is required',
      payEndTime: 'End Time',
      payEndTimePlaceholder: 'Select end time',
      payEndTimeRequired: 'End time is required',
      payEndTimeAfterStart: 'End time must be after start time',
      deleteFeeConfirm: 'Are you sure to delete this payment time?',
      feeIdRequired: 'Fee ID is required',
      
      // Tab names
      integralRuleConfig: 'Integral Standard',
      integralRuleFee: 'Payment Time',
      
      // Messages
      fetchError: 'Failed to fetch data',
      selectRuleFirst: 'Please select a rule first'
    },
  },
  zh: {
    integralRule: {
      page: {
        title: '积分规则',
        subtitle: '管理积分计算规则、额度配置与缴费设置'
      },
      addTitle: '添加积分规则',
      editTitle: '编辑积分规则',
      deleteTitle: '删除积分规则',
      deleteConfirm: '确定删除该积分规则吗？',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过64个字符',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkRequired: '备注不能为空',
      remarkMaxLength: '备注不能超过512个字符',
      ruleIdRequired: '规则ID不能为空',
      selectRule: '请先选择规则',
      
      // Config related
      addConfigTitle: '添加积分标准',
      configId: '配置ID',
      configName: '配置名称',
      configPlaceholder: '请选择配置',
      configRequired: '配置不能为空',
      deleteConfigConfirm: '确定删除该配置吗？',
      computingFormula: '计算公式',
      squarePrice: '单价',
      additionalAmount: '固定积分',
      scale: '进位',
      
      // Fee related
      addFeeTitle: '添加缴费时间',
      editFeeTitle: '编辑缴费时间',
      feeId: '费用ID',
      payTimeRange: '缴费时间范围',
      payStartTime: '开始时间',
      payStartTimePlaceholder: '选择开始时间',
      payStartTimeRequired: '开始时间不能为空',
      payEndTime: '结束时间',
      payEndTimePlaceholder: '选择结束时间',
      payEndTimeRequired: '结束时间不能为空',
      payEndTimeAfterStart: '结束时间必须晚于开始时间',
      deleteFeeConfirm: '确定删除该缴费时间吗？',
      feeIdRequired: '费用ID不能为空',
      
      // Tab names
      integralRuleConfig: '积分标准',
      integralRuleFee: '缴费时间',
      
      // Messages
      fetchError: '获取数据失败',
      selectRuleFirst: '请先选择规则'
    },
  }
}